import classnames from "classnames";
import * as React from "react";
import { Node, NodeChildProps, Remove } from "reaflow";
import {
  BaseNodeComponentType,
  BaseNodeDataType,
  BaseNodePropsType,
  SpecializedNodeProps,
} from "../WorkflowUtils";
import BasePort from "../Port/BasePort";
import BasePortChild from "../Port/BasePortChild";
import { UNodeType } from "@supportinitiative/common";

const BaseNode: BaseNodeComponentType<BaseNodePropsType> = (props) => {
  const {
    children, // Don't forward, overridden in this file
    node, // Don't forward, not expected
    allNodes,
    allEdges,
    selectedNode,
    isDisabled,
    onNodeClick: onNodeClickInternal,
    onPortDragEnd: onPortDragEnd,
    ...nodeProps // All props that are left will be forwarded to the Node component
  } = props;

  const nodeType: UNodeType = node?.data?.type as UNodeType;
  const selected = node.id === selectedNode?.id;

  const onNodeRemove = (event: React.MouseEvent<SVGGElement, MouseEvent>) => {
    // console.log("onNodeRemove", event, node);
  };

  const onNodeClick = (event: React.MouseEvent<SVGGElement, MouseEvent>) => {
    // console.log(`node clicked (${node?.data?.type})`, "node:", node);
    onNodeClickInternal(node);
  };

  const onNodeEnter = (
    event: React.MouseEvent<SVGGElement, MouseEvent>,
    node: BaseNodeDataType
  ) => {
    // console.log("onNodeEnter", event.target);
  };

  const onNodeLeave = (
    event: React.MouseEvent<SVGGElement, MouseEvent>,
    node: BaseNodeDataType
  ) => {
    // console.log("onNodeLeave", event.target);
  };

  const onKeyDown = (
    event: React.KeyboardEvent<SVGGElement>,
    node: BaseNodeDataType
  ) => {
    // console.log("onKeyDown", event, node);
  };

  return (
    <Node
      {...nodeProps}
      style={{
        strokeWidth: 0,
        // fill: isReachable ? 'white' : '#eaeaea',
        color: "black",
        cursor: "auto",
      }}
      className={`node-svg-rect node-${nodeType.toUpperCase().includes("GROUP") ? "group" : nodeType.toLowerCase()}-svg-rect`}
      onClick={onNodeClick}
      onEnter={onNodeEnter}
      onLeave={onNodeLeave}
      onKeyDown={onKeyDown}
      onRemove={onNodeRemove}
      remove={<Remove hidden={true} />}
      dragType="port" // This is the drag type used by the Port component to determine how to handle the drag event
      draggable={true} // Allow the node to be draggable
      port={
        // No need to show inside parent. Better to use Add button of group/parent or add through edge
        isDisabled || node.parent ? (
          <></>
        ) : (
          <BasePort
            fromNodeId={node.id}
            allNodes={allNodes}
            allEdges={allEdges}
            onPortDragEnd={onPortDragEnd}
            additionalPortChildProps={{
              allNodes: allNodes,
              allEdges: allEdges,
              fromNode: node,
              isNodeReachable: true, // Placeholder, should be determined by the node's state
            }}
            PortChildComponent={BasePortChild}
          />
        )
      }
    >
      {(nodeProps: NodeChildProps) => {
        const { width, height } = nodeProps;
        const specializedNodeProps: SpecializedNodeProps = {
          ...nodeProps,
        };

        return (
          <foreignObject
            id={`node-foreignObject-${node.id}`} // Used during drag & drop of edges to resolve the destination node ("toNode")
            className={`node-container ${nodeType.toUpperCase().includes("GROUP") ? "group" : nodeType.toLowerCase()}-node-container`}
            width={width}
            height={height}
            // x={0} // Relative position from the parent Node component (aligned to top)
            // y={0} // Relative position from the parent Node component (aligned to left)
            // Use the same onClick/onMouseEnter/onMouseLeave handlers as the one used by the Node component, to yield the same behavior whether clicking on the <rect> or on the <foreignObject> element
            onClick={onNodeClick as React.MouseEventHandler}
            onMouseEnter={onNodeEnter as React.MouseEventHandler}
            onMouseLeave={onNodeLeave as React.MouseEventHandler}
            onKeyDown={onKeyDown as React.KeyboardEventHandler}
          >
            <div
              className={`node ${nodeType.toUpperCase().includes("GROUP") ? "group" : nodeType.toLowerCase()}-workflow-node default-workflow-node`}
            >
              <div
                className={`node-content-container ${nodeType.toUpperCase().includes("GROUP") ? "group" : nodeType.toLowerCase()}-content-container`}
              >
                {
                  // Invoke the children as a function, or render the children as a component, if it's not a function
                  // @ts-ignore
                  typeof children === "function"
                    ? children({ ...specializedNodeProps })
                    : children
                }
              </div>
            </div>
          </foreignObject>
        );
      }}
    </Node>
  );
};

export default BaseNode;
